import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import PackageCard from '../../../../components/customer/PublicCustomerScreens/PackagesComponent/PackageCard';
import '../../../../assets/css/customer/publicCustomerCss/CusPackages/cuspackages.css';
import AppContext from '../../../../context/AppContext';
import ServerConnectionLost from '../../../../components/general/ConnectionLost';
import { useNavigate } from 'react-router-dom';

const PackageSlider = () => {
    const [packages, setPackages]     = useState([]);
    const [loading, setLoading]       = useState(true);
    const [error, setError]           = useState(null);
    const [expandedCard, setExpanded] = useState(null);
    const [activeDot, setActiveDot]   = useState(0);
    const scrollRef                   = useRef(null);
    const [connectionLost, setConnectionLost] = useState(false);
    const { baseUrl, authToken } = useContext(AppContext);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        axios
            .get(`${baseUrl}/customer/view-cus-packages`)
            .then((response) => {
                const data = response.data?.data ?? [];
                setPackages(data);
            })
            .catch((err) => {
                console.error('Fetch packages error:', err);
                setConnectionLost(true);
            })
            .finally(() => setLoading(false));
    }, []);

    const scrollCards = (dir) => {
        const c = scrollRef.current;
        if (!c) return;
        c.scrollBy({
            left: dir === 'left' ? -(c.clientWidth / 2) : c.clientWidth / 2,
            behavior: 'smooth',
        });
    };

    const handleScroll = () => {
        const c = scrollRef.current;
        if (!c || !packages.length) return;
        const cardWidth = c.scrollWidth / packages.length;
        const index = Math.round(c.scrollLeft / cardWidth);
        setActiveDot(Math.min(index, packages.length - 1));
    };

    const goToCard = (index) => {
        const c = scrollRef.current;
        if (!c) return;
        const cardWidth = c.scrollWidth / packages.length;
        c.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
    };

    const handleToggle = (id) =>
        setExpanded(prev => (prev === id ? null : id));

    if (connectionLost) {
        return <ServerConnectionLost />;
    }
    if (loading) return (
        <div className="pub-pack-packages-screen">
            <div className="pub-pack-state-center">
                <div className="pub-pack-spinner" />
                <p>Loading packages…</p>
            </div>
        </div>
    );

    if (error) return (
        <div className="pub-pack-packages-screen">
            <div className="pub-pack-state-center pub-pack-state-error">
                <p>⚠ {error}</p>
                <button onClick={() => window.location.reload()}>Retry</button>
            </div>
        </div>
    );

    if (!packages.length) return (
        <div className="pub-pack-packages-screen">
            <div className="pub-pack-state-center">
                <p>No packages available at the moment.</p>
            </div>
        </div>
    );

    return (
        <div className="pub-pack-packages-screen">

            <div className="pub-pack-packages-header">
                <h1 className="pub-pack-header-title">Explore Pakistan</h1>
                <p className="pub-pack-header-subtitle">
                    Find the perfect plan for your dream destination
                </p>
            </div>

            <div className="pub-pack-slider-wrapper">
                <button
                    className="pub-pack-nav-btn left"
                    onClick={() => scrollCards('left')}
                    aria-label="Scroll left"
                >
                    &#10094;
                </button>

                <div
                    className="pub-pack-packages-scroll-container"
                    ref={scrollRef}
                    onScroll={handleScroll}
                >
                    {packages.map(pkg => (
                        <PackageCard
                            key={pkg.id}
                            packageData={pkg}
                            onToggle={handleToggle}
                            isExpanded={expandedCard === pkg.id}
                            otherCardsShrink={
                                expandedCard !== null && expandedCard !== pkg.id
                            }
                        />
                    ))}
                </div>

                <button
                    className="pub-pack-nav-btn right"
                    onClick={() => scrollCards('right')}
                    aria-label="Scroll right"
                >
                    &#10095;
                </button>
            </div>

            <div className="pub-pack-dots">
                {packages.map((_, index) => (
                    <span
                        key={index}
                        className={`pub-pack-dot${index === activeDot ? ' active' : ''}`}
                        onClick={() => goToCard(index)}
                    />
                ))}
            </div>

        </div>
    );
};

export default PackageSlider;